"use client";

import React from "react";
import { motion } from "framer-motion";
import { Quote, ShieldCheck, Zap, Wrench } from "lucide-react";
import { Card, CardHeader, CardContent, CardFooter, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const testimonials = [{
  id: 1,
  name: "Sarah Jenkins",
  location: "Atlanta, GA",
  text: "When our breaker panel started acting up, Handy Heroes connected us with an independent local electrician quickly. They evaluated the situation, provided a clear quote, and completed the panel replacement smoothly.",
  service: "Panel Repair",
  icon: Zap,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/avatar_customer_1.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/avatar_customer_1.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/avatar_customer_1.webp-wvc-sizes",
    alt: "Sarah Jenkins"
  }
}, {
  id: 2,
  name: "Marcus Thorne",
  location: "Marietta, GA",
  text: "We hired a pro through the platform to install EV chargers and evaluate our home's wiring. The work was cleanly done, code-compliant, and the pro was very knowledgeable about local permitting requirements.",
  service: "Installation",
  icon: Wrench,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/avatar_customer_2.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/avatar_customer_2.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/avatar_customer_2.png-wvc-sizes",
    alt: "Marcus Thorne"
  }
}, {
  id: 3,
  name: "Emily Chen",
  location: "Roswell, GA",
  text: "Finding a reliable electrician used to be a hassle. The independent pro we connected with diagnosed our recurring lighting issue and explained everything clearly before starting the repair.",
  service: "Lighting Troubleshooting",
  icon: ShieldCheck,
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/avatar_customer_3.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/avatar_customer_3.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/avatar_customer_3.png-wvc-sizes",
    alt: "Emily Chen"
  }
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};
export default function ElectricalServiceTestimonials() {
  return <section id="electricalservicetestimonials" className="bg-background py-24 sm:py-32 overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <Badge variant="secondary" className="mb-4">
            <ShieldCheck className="mr-1 size-4 text-primary" />
            Customer Feedback
          </Badge>
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Homeowner Experiences
          </h2>
          <p className="mt-4 text-lg leading-8 text-muted-foreground">
            See what homeowners say about independent electrical pros found on Handy Heroes.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.2
      }} className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {testimonials.map((testimonial, index) => {
          const Icon = testimonial.icon;
          return <motion.div key={testimonial.id} variants={itemVariants} data-index={index}>
                <Card className="flex h-full flex-col justify-between shadow-md hover:shadow-lg transition-shadow duration-300 border-border/50">
                  <CardHeader className="pb-4">
                    <div className="flex items-center justify-between mb-4">
                      <Badge variant="outline" className="bg-background/50">
                        <Icon className="mr-1 size-3 text-primary" />
                        {testimonial.service}
                      </Badge>
                    </div>
                    <Quote className="size-8 text-muted/40 mb-2" />
                    <CardDescription className="text-base text-foreground leading-relaxed">
                      "{testimonial.text}"
                    </CardDescription>
                  </CardHeader>
                  <CardFooter className="pt-4 border-t border-border/30 mt-auto">
                    <div className="flex items-center gap-4">
                      <img src={testimonial.image.src} data-wvc-srcset={testimonial.image.srcset} data-wvc-sizes={testimonial.image.sizes} alt={testimonial.image.alt} className="size-12 rounded-lg object-cover bg-muted" loading="lazy" />
                      <div>
                        <div className="font-default font-semibold text-foreground">
                          {testimonial.name}
                        </div>
                        <div className="text-sm text-muted-foreground">
                          {testimonial.location}
                        </div>
                      </div>
                    </div>
                  </CardFooter>
                </Card>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}